module.exports = __webpack_public_path__ + "img/62400.dfe55c8b.jpg";